import { render, staticRenderFns } from "./study1.vue?vue&type=template&id=3bdf0d8a&scoped=true&"
import script from "./study1.vue?vue&type=script&lang=js&"
export * from "./study1.vue?vue&type=script&lang=js&"
import style0 from "./study1.vue?vue&type=style&index=0&id=3bdf0d8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf0d8a",
  null
  
)

export default component.exports